import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {BehaviorSubject} from 'rxjs';
import {AuthService} from '../../shared/services/auth.service';
import {environment} from 'src/environments/environment';
import {Rate} from '../interface/rate';

@Injectable({
    providedIn: 'root'
})
export class RateService {
    rate: any;

    constructor(protected http: HttpClient, private auth: AuthService) {
        this.rate = new BehaviorSubject<any>(null);
    }

    getHeaders() {
        const token = 'Bearer ' + this.auth.getToken();

        return new HttpHeaders({
            Authorization: token,
            'Content-Type': 'application/json'
        });
    }

    getRates(access: string = null) {
        let url = environment.amenaEndpoint + 'master/rates';

        if (access != null) {
            let way = 'access';

            if (access.toLowerCase().match('mobile') || access.toLowerCase().match('4g')) {
                way = 'type';
            }

            url += '?' + way + '=' + access;
        }

        return this.http.get(url, {headers: this.getHeaders()});
    }

    setRate(rate: Rate) {
        this.rate.next(rate);
    }

    getRate() {
        return this.rate.asObservable();
    }
}
